import { DataLevel, ResultAPI, StructureType } from '@/lib/model';

export const getMapSettings = (type: StructureType, level?: DataLevel) => {
  // CAMERA
  if (type === StructureType.CAMERA) {
    switch (level) {
      case DataLevel.COMUNE_FRAZ:
        return {
          layerPropId: 'PRO_COM_CU',
          sourceLayer: '25_CAMERA_FRAZCOM',
          zoom: 9,
        };

      case DataLevel.COMUNE:
        return {
          layerPropId: 'PRO_COM',
          sourceLayer: '25_Comuni_5',
          zoom: 8,
        };

      case DataLevel.COLLEGIO:
        return {
          layerPropId: 'CU20_COD',
          sourceLayer: '25_CAMERA_CollegiUN_2020',
          zoom: 7,
        };

      case DataLevel.CIRCOSCRIZIONE:
        return {
          layerPropId: 'CIRC_COD',
          sourceLayer: '25_Circo_Camera_2020',
          zoom: 6,
        };

      case DataLevel.NAZIONALE:
      default:
        return {
          layerPropId: 'CIRC_COD',
          sourceLayer: '25_Circo_Camera_2020',
          zoom: 4.5,
        };
    }
  }

  // SENATE
  switch (level) {
    case DataLevel.COMUNE_FRAZ:
      return {
        layerPropId: 'PRO_COM_SU',
        sourceLayer: '25_SENATO_FRAZCOM',
        zoom: 9,
      };

    case DataLevel.COMUNE:
      return {
        layerPropId: 'PRO_COM',
        sourceLayer: '25_Comuni_5',
        zoom: 8,
      };

    case DataLevel.COLLEGIO:
      return {
        layerPropId: 'SU20_COD',
        sourceLayer: '25_SENATO_CollegiUN_2020',
        zoom: 7,
      };

    case DataLevel.CIRCOSCRIZIONE:
      return {
        layerPropId: 'COD_REG',
        sourceLayer: '25_Regioni_Senato_2020',
        zoom: 6,
      };

    case DataLevel.NAZIONALE:
    default:
      return {
        layerPropId: 'COD_REG',
        sourceLayer: '25_Regioni_Senato_2020',
        zoom: 4.5,
      };
  }
};

export const getLevelSettings = (
  level: DataLevel
): {
  directory: string;
  nextLevel: DataLevel | null;
  variable: keyof ResultAPI['int'];
} => {
  switch (level) {
    case DataLevel.COMUNE_FRAZ:
      return {
        directory: 'comuni_completo',
        variable: 'cod_circ',
        nextLevel: null,
      };

    case DataLevel.COMUNE:
      return {
        directory: 'comuni',
        variable: 'cod_circ', // will be anyway overriden with PRO_COM
        nextLevel: DataLevel.COMUNE_FRAZ,
      };

    case DataLevel.COLLEGIO:
      return {
        directory: 'collegi',
        variable: 'cod_cl_uni',
        nextLevel: DataLevel.COMUNE_FRAZ,
      };

    case DataLevel.CIRCOSCRIZIONE:
      return {
        directory: 'regioni',
        variable: 'cod_circ',
        nextLevel: DataLevel.COLLEGIO,
      };

    case DataLevel.NAZIONALE:
    default:
      return {
        directory: '', // set in different place
        variable: 'cod_circ',
        nextLevel: DataLevel.CIRCOSCRIZIONE,
      };
  }
};
